export const BOTS = {
  n8n: {
    name: "Chat QTM",
    endpoint: "/api/chat/n8n",
    logo: "https://i.ibb.co/DfXdPcVd/Quanterm-Official-Logo-High-Reso-01.png"
  },
  langflow: {
    name: "Beta Test (demo)",
    endpoint: "/api/chat/langflow",
    logo: "https://i.ibb.co/DfXdPcVd/Quanterm-Official-Logo-High-Reso-01.png"
  }
};
